export default __webpack_public_path__ + "static/media/eCompliance.8687b54f.png";